import P2Regular from 'components/typography/P2Regular';
import { UserRow } from 'components/tables/data/user/types';

/**
 * Column for the migrated from v1 note.
 */
export default function MigratedFromV1NoteColumn({ data: { migratedFromV1Note } }: { data: UserRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {migratedFromV1Note}
    </P2Regular>
  );
}
